import { BootIndexIcon as SharedUiBootIndexIcon } from "shared-ui"

export default function BootIndexIcon({ color, bootBackendCode, bootNameLocalised, hoverOverlayText = true, ...props }) {

    return <SharedUiBootIndexIcon
        color={color}
        bootBackendCode={bootBackendCode}
        bootNameLocalised={bootNameLocalised}
        hoverOverlayText={hoverOverlayText}
        {...props}
    />
}